import { createSelector, Selector } from 'reselect';
import { getGranulometryState } from '../../reducers';
import { State } from '../../../store/reducers';

export const selectIsGranulometryFresh: Selector<State, boolean> = createSelector(
  [getGranulometryState],
  (state) => state.isFresh
);
